import { useMutation } from "@apollo/client"
import { ROUND_REPORT } from "../queries/roundReport"

interface RoundReportInput {
  id: number
  dropOpponent: boolean
  dropPlayer: boolean
  roundId: number
  table: number
  tournamentId: number
  winnerId: number
  loserId: number
  draw: boolean
  winnerVictories: number
  winnerDefeats: number
  winnerDraws: number
  loserVictories: number
  loserDefeats: number
  loserDraws: number
}

export const useRoundReport = () => {
  const [roundReportMutation, { loading, error }] = useMutation(ROUND_REPORT)

  const roundReport = async (input: RoundReportInput) => {
    try {
      const { data } = await roundReportMutation({
        variables: { RoundReportInput: input },
      })
      return data?.RoundReport
    } catch (error) {
      console.error("Error reporting round result:", error)
      throw error
    }
  }

  return {
    roundReport,
    loading,
    error,
  }
}
